// extracted by mini-css-extract-plugin
export default {"error":"Error_error__i4zUL","container":"Error_container__GFi1U"};